module.exports = __webpack_public_path__ + "img/53e2ebc0ab763d0d046c653b5a4430cd.png";